<template>
  <v-container fluid>
    <faq-list></faq-list>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-tabs v-model="activeTab" background-color="transparent" grow>
              <v-tab>FAQs</v-tab>
              <v-tab>Categories</v-tab>
            </v-tabs>

            <v-tabs-items v-model="activeTab">
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <FAQList></FAQList>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <FAQCategoryList></FAQCategoryList>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FAQList from "@/components/faq/FAQList.vue";
import FAQCategoryList from "@/components/faq/FAQCategoryList.vue";

export default {
  name: "FAQManagementPage",
  components: {
    FAQList,
    FAQCategoryList,
  },
  data() {
    return {
      activeTab: 0,
    };
  },
};
</script>

<style scoped>
.text-h4 {
  font-weight: 400;
}
</style>
